import React from "react";
import CurrencBody from "../CurrencBody";
import { useAppContext } from "../../context";


export default function CashCourse() {
    const { currentRateData, setCurrencyData } = useAppContext();

    React.useEffect(() => {
        setCurrencyData(true);
    }, [setCurrencyData]);
    return (
        <>
            <CurrencBody data={currentRateData} /> 

        </>
    );
}
